import React, { useEffect, useState } from 'react';
import { Map, Marker, InfoWindow, GoogleApiWrapper } from 'google-maps-react';
import styles from '../listings/forms/addpost.module.css'

const MapContainer = (props) => {

  const [showingInfoWindow, setShowingInfoWindow] = useState(false);
  const [activeMarker, setActiveMarker] = useState(null)
  const [selectedPlace, setSelectedPlace] = useState({})
  const [bounds, setBounds] = useState({});

  useEffect(() => {
    const boundsObj = new props.google.maps.LatLngBounds();
    props.listing.address.forEach(bound => {
      if (bound.lattitude && bound.longitude)
        boundsObj.extend({ lat: parseFloat(bound.lattitude), lng: parseFloat(bound.longitude) })
    })
    setBounds(boundsObj)
  }, [])

  const onMarkerClick = (props, marker, e) => {
    setSelectedPlace(props)
    setActiveMarker(marker)
    setShowingInfoWindow(true)
  }

  const onMapClicked = () => {
    if (showingInfoWindow) {
      setShowingInfoWindow(false)
      setActiveMarker(null)
    }
  };

  const style = {
    width: '100%',
  }

  return (
    <div className={styles.mapContainer}>
      <Map style={style}
        google={props.google}
        onClick={onMapClicked}
        bounds={bounds}
        minZoom={4}>
        {props.listing.address.map((marker, index) => (
          <Marker key={index}
            name={marker.address}
            title={marker.address}
            position={{ lat: marker.lattitude, lng: marker.longitude }}
            onClick={onMarkerClick}
          />
        ))}
        <InfoWindow
          marker={activeMarker}
          visible={showingInfoWindow}>
          <div>
            <h4 className="info_text">{props.listing.businessName}</h4>
            <h6 className="info_text">{selectedPlace.name}</h6></div>
        </InfoWindow>
      </Map>
    </div>
  )
}

export default (GoogleApiWrapper({ apiKey: (process.env.REACT_APP_GOOGLE_MAP_API_KEY) })(MapContainer));